const checkIfWidget = () => {
  const { href } = window.location;
  return (href.search(/(localhost:8080|widgets.*\.resy\.com)/) > -1);
};

export default checkIfWidget;
